// Helpers, constantes et styles partagés entre Sidebar.js et ses composants extraits.
// Extrait verbatim de src/components/Sidebar.js (découpe iso du 06/09/2026).
import { LayoutDashboard, Ticket, Monitor, Building, Wrench, DollarSign, Package, BookOpen, Sparkles, Target, GraduationCap, Globe, Cloud, ShieldAlert, Lock, BarChart3, Radar, Share2, Container, Server, Settings, Users } from 'lucide-react';

/* ── Section icons for collapsed sidebar ───────────────────────────────── */
export const SECTION_ICONS = {
  portail: LayoutDashboard,
  ticketing: Ticket,
  parc: Monitor,
  gestion: Building,
  clients: Building,
  administration: Wrench,
  comptabilite: DollarSign,
  catalogue: Package,
  kb: BookOpen,
  assistant: Sparkles,
  crm: Target,
  formation: GraduationCap,
  outils: Globe,
  microsoft365: Cloud,
  incidents: ShieldAlert,
  securite: Lock,
  rapports: BarChart3,
  veille: Radar,
  social: Share2,
  docker: Container,
  vmware: Server,
  proxmox: Server,
  configuration: Wrench,
  admin: Settings,
  rh: Users,
};

export const TYPE_CONFIG = {
  feature:  { label: 'Nouveauté',    color: '#27ae60', bg: '#eafaf1' },
  fix:      { label: 'Correction',   color: '#e74c3c', bg: '#fde8e8' },
  refactor: { label: 'Refactoring',  color: '#8e44ad', bg: '#f3e8ff' },
  perf:     { label: 'Performance',  color: '#e67e22', bg: '#fef9e7' },
  other:    { label: 'Autre',        color: '#6b7d8f', bg: '#f4f7fb' },
};
